/**
 * Bundled FHIR-aligned sample VITALS (ObservationView) — demo fallback.
 *
 * Used by VitalsPanel when the deployed site cannot reach the clinical API
 * (or the patient has no rows yet): the section renders these contract-exact
 * samples with a "Sample data" badge so the demo stays fully clickable.
 *
 * Shapes mirror apps/api/app/schemas/vital.py VitalObservationView EXACTLY:
 *   vital_type, snomed_code, value: { value, unit }, effective_datetime,
 *   entered_by_source ('patient' | 'clinician' | 'import').
 */
import type { ObservationView } from '../../api/vitals'

const PATIENT_ID = '7f381bff-5fa9-4fee-92a0-f8e21a163e19'

export const SAMPLE_VITALS: ObservationView[] = [
  {
    id: '9d000001-0000-4000-8000-000000000001',
    resource_type: 'Observation',
    patient_id: PATIENT_ID,
    vital_type: 'blood_pressure_systolic',
    snomed_code: '163030003',
    value: { value: 128, unit: 'mmHg' },
    effective_datetime: '2026-08-27T09:00:00Z',
    entered_by_source: 'clinician',
  },
  {
    id: '9d000001-0000-4000-8000-000000000002',
    resource_type: 'Observation',
    patient_id: PATIENT_ID,
    vital_type: 'blood_pressure_diastolic',
    snomed_code: '163031004',
    value: { value: 84, unit: 'mmHg' },
    effective_datetime: '2026-08-27T09:00:00Z',
    entered_by_source: 'clinician',
  },
  {
    id: '9d000001-0000-4000-8000-000000000003',
    resource_type: 'Observation',
    patient_id: PATIENT_ID,
    vital_type: 'weight',
    snomed_code: '294636000',
    value: { value: 78.4, unit: 'kg' },
    effective_datetime: '2026-08-25T07:30:00Z',
    entered_by_source: 'patient',
  },
  {
    id: '9d000001-0000-4000-8000-000000000004',
    resource_type: 'Observation',
    patient_id: PATIENT_ID,
    vital_type: 'height',
    snomed_code: '1153637007',
    value: { value: 175, unit: 'cm' },
    effective_datetime: '2026-08-12T08:00:00Z',
    entered_by_source: 'patient',
  },
  {
    id: '9d000001-0000-4000-8000-000000000005',
    resource_type: 'Observation',
    patient_id: PATIENT_ID,
    vital_type: 'o2_saturation',
    snomed_code: '431314004',
    value: { value: 98, unit: '%' },
    effective_datetime: '2026-08-27T09:00:00Z',
    entered_by_source: 'clinician',
  },
  {
    id: '9d000001-0000-4000-8000-000000000006',
    resource_type: 'Observation',
    patient_id: PATIENT_ID,
    vital_type: 'pain_level',
    snomed_code: '382144000',
    value: { value: 3, unit: '{0-10}' },
    effective_datetime: '2026-08-24T20:00:00Z',
    entered_by_source: 'patient',
  },
]
